module.exports = __webpack_public_path__ + "img/wallet.5efa735b.svg";